import { render } from "./HomeDescriptionBanner.vue?vue&type=template&id=06b5ad87&scoped=true&ts=true"
import script from "./HomeDescriptionBanner.vue?vue&type=script&lang=ts"
export * from "./HomeDescriptionBanner.vue?vue&type=script&lang=ts"

import "./HomeDescriptionBanner.vue?vue&type=style&index=0&id=06b5ad87&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b5ad87"]])

export default __exports__